import React from "react";
import { Link } from "react-router-dom";
import { GitCompareArrows, X } from "lucide-react";
import { useComparatorCart } from "../contexts/ComparatorCartContext";
import { MiniKenoBall } from "./MiniKenoBall";
import styles from "./ComparatorCart.module.css";

export function ComparatorCart() {
  const { numbers, removeNumber, clearCart, count } = useComparatorCart();

  if (count === 0) return null;

  return (
    <div className={styles.cart}>
      <div className={styles.cartHeader}>
        <GitCompareArrows size={16} />
        <span className={styles.cartTitle}>Comparateur</span>
        <span className={styles.cartCount}>{count}/8</span>
      </div>

      <div className={styles.cartNumbers}>
        {numbers.map(num => (
          <div key={num} className={styles.cartNumber}>
            <MiniKenoBall number={num} size="sm" />
            <button
              className={styles.removeBtn}
              onClick={() => removeNumber(num)}
              title="Retirer"
            >
              <X size={12} />
            </button>
          </div>
        ))}
      </div>

      <div className={styles.cartActions}>
        <button className={styles.clearBtn} onClick={clearCart}>
          Vider
        </button>
        <Link
          to={`/comparateur?numeros=${numbers.join(",")}`}
          className={styles.viewBtn}
        >
          Comparer
        </Link>
      </div>
    </div>
  );
}
